import { i18n } from "@v2/shared/config";
import { axios } from "@v2/shared/api";
const COUNTRY_ENDPOINT = "countries";

export default {
  getCountryList() {
    return axios.get(COUNTRY_ENDPOINT, {
      params: {
        order: i18n.locale === "en" ? "name_eng" : "name_rus"
      }
    });
  }
};
